module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9a1be90552ed9ae76f6c4b963e9e3fa7.png";